<template>
  <div class="companyProduct" ref="contents">
    <div class="headView">
      <p class="text">
        <span class="icon">!</span>
        同学们，源代码是用来学习的喔，请大家尊重其他同学的版权，不要出售买来的作品哦~~
      </p>
    </div>
    <div class="products">
      <div class="product" v-for="(item, index) in data" :key="item.pk" @click="jumpToWorkDetail(item)">
        <div class="img" :style="{ height: `${workHeight}px`, backgroundImage:`url(${getImg(item.showwork.images)})` }"></div>
        <div class="text">
          <div class="name">
            <span class="title">{{ item.showwork.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { Utils } from "../utils";

import { types as ConfirmTypes } from "../store/modules/confirm";
import { types as CompanyTypes } from "../store/modules/company";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "MyBuyWorkList",
  components: {
  },
  props: {},
  data() {
    return {
        workHeight: 150
    };
  },
  watch: {},
  computed: {
    ...mapState({
        page: state => state.company.buy_work.page,
        load_more: state => state.company.buy_work.load_more,
        data: state => state.company.buy_work.data
    })
  },
  methods: {
    ...mapActions({
        fetchMyBuyWorks: CompanyTypes.FETCH_MY_BUY_WORKS
    }),
    ...Utils,
    //作品详情页
    jumpToWorkDetail(item) {
        // console.log("进入详情页");
        let pk = item.showwork.pk;
      let host = location.host;
      if (location.host.indexOf("develop.cxy61.com") > -1) {
        host = "app.bcjiaoyu.com";
      }
      window.open(
        `https://${host}/html/works/works_detail.html?pk=${pk}`,
        "_blank"
      );
    },
    handleScroll(e) {
      var that = this;
      let height = document.body.clientHeight;
      let scrollHeight = document.body.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      
      // if(e && e.target){
      //   height = e.target.offsetHeight
      //   scrollHeight = e.target.scrollHeight
      //   scrollTop = e.target.scrollTop
      // }
      
      // console.log("帖子列表:", height, scrollHeight, scrollTop);
      if (scrollHeight <= height + scrollTop + 20) {
        if (that.load_more) {
          // console.log("还有更多数据，到达底部，继续加载新数据(帖子)");
         that.fetchMyBuyWorks({page: that.page + 1, user_id: that.user_id})
        } else {
          // console.log("没有新数据了");
        }
      } else {
        // console.log("没到底部");
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.workHeight = (this.$refs.contents.clientWidth - 30) / 4 - 10 - 2;
    let user_id = this.$route.params.user
    this.user_id = user_id;
    this.fetchMyBuyWorks({page: 1, user_id: this.user_id})
  }
};
</script>

<style lang="less" scoped>
.companyProduct {
  background-color: #ffffff;
  padding: 15px;
  .headView {
    margin-bottom: 15px;
    margin-left: 10px;
    .text {
      color: #6b45e1;
      font-size: 12px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .icon{
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #6B45E1;
        display: inline-block;
        color: #ffffff;
        text-align: center;
        line-height: 20px;
        font-size: 13px;
        // font-weight: bold;
        margin-right: 5px;
      }
    }
  }
  .products {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: calc(100%);
    margin: auto;
    margin-left: 5px;
  }
  .product {
    background-color: #ffffff;
    border: solid 1px #ebebeb;
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    border-radius: 8px;
    overflow: hidden;
    width: calc(100% / 4 - 12px);
    .img {
      width: 100%;
      height: 150px;
      background-color: #e1e1e1;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }
    .text {
      padding-left: 10px;
      padding-right: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      font-size: 12px;
      .name {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
        margin-bottom: 10px;
        .title {
          color: #2d2d2d;
          height: 20px;
          line-height: 20px;
          overflow: hidden;
          flex: 1;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
